import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { db } from "../firebase";
// import { collection, getDocs } from "firebase/firestore";
import {
  collection,
  getDocs,
} from "firebase/firestore";

export default function AnimatedCounters() {
  const [marquesCount, setMarquesCount] = useState(0);
  const [modelesCount, setModelesCount] = useState(0);

  useEffect(() => {
    const fetchCounts = async () => {
      const marquesSnap = await getDocs(collection(db, "marques"));
      setMarquesCount(marquesSnap.size);

      let totalModeles = 0;
      for (const doc of marquesSnap.docs) {
        const modelesSnap = await getDocs(collection(db, `marques/${doc.id}/modeles`));
        totalModeles += modelesSnap.size;
      }

      setModelesCount(totalModeles);
    };

    fetchCounts();
  }, []);

  return (
    <section className="bg-light py-5 text-center">
      <div className="container">
        <h3 className="fw-bold mb-4 text-dark">🔢 Nos chiffres clés</h3>
        <div className="row justify-content-center g-4">
          <div className="col-md-4">
            <h1 className="text-primary">
              <CountUp end={marquesCount} duration={2} />
            </h1>
            <p className="fw-semibold">Marques disponibles</p>
          </div>
          <div className="col-md-4">
            <h1 className="text-success">
              <CountUp end={modelesCount} duration={2} />
            </h1>
            <p className="fw-semibold">Modèles de véhicules</p>
          </div>
          <div className="col-md-4">
            <h1 className="text-warning">
              <CountUp end={250} duration={2} suffix="+" />
            </h1>
            <p className="fw-semibold">Clients satisfaits</p>
          </div>
        </div>
      </div>
    </section>
  );
}
